import { Link } from 'react-router-dom';
import '../App.css';
import Header from '../components/Header';
import { Helmet } from 'react-helmet-async';

const GROUP_ACCOUNTABILITY_STRUCTURE_URL =
  'https://grahamcare.co.uk/Shared%20Files/GC%20Group%20Accountability%20Structure.docx';

const QUALITY_COMPLIANCE_BOARD_TOR_URL =
  'https://grahamcare.co.uk/Shared%20Files/GC%20Quality%20&%20Compliance%20Board%20Terms%20of%20Reference.doc';

function Governance() {
  return (
    <>
      <Helmet>
        <title>Governance | Graham Care</title>
        <meta
          name="description"
          content="Graham Care governance: Quality and Compliance Board oversight, group accountability structure, and terms of reference."
        />
      </Helmet>

      <div className="page">
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        <Header />

        <main id="main-content">
          <section className="content-section governance-page">
            <div className="governance-container">
              <h1>Governance</h1>

              <div className="governance-content">
                <p>
                  Our Quality and Compliance Board has oversight of the care outcomes which our residents
                  experience.
                </p>
                <p>
                  The accountability structure in which the Board operates is:{' '}
                  <a
                    href={GROUP_ACCOUNTABILITY_STRUCTURE_URL}
                    className="nurse-care-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Group Accountability Structure
                  </a>
                </p>
                <p>
                  and its terms of reference is:{' '}
                  <a
                    href={QUALITY_COMPLIANCE_BOARD_TOR_URL}
                    className="nurse-care-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Quality Compliance Board Terms of Reference
                  </a>
                </p>
              </div>
            </div>
          </section>
        </main>

        <footer className="footer">
          <section className="footer__enquiry">
            <div className="footer__enquiry-container">
              <Link to="/contact-us" className="footer__enquiry-link">
                Enquire about Graham Care <span className="footer__arrow">▶</span>
              </Link>
            </div>
          </section>
          <div className="footer__container">
            <section className="contact-section">
              <div className="contact-section__content">
                <p>Graham Care Ltd, KT15 1HH</p>
                <p>Copyright © Graham Care Ltd</p>
              </div>
            </section>
          </div>
        </footer>
      </div>
    </>
  );
}

export default Governance;
